import { MutableRefObject, useEffect, useState } from "react";
import { CatalogueItemAuctionPostbackStatus } from "../_common/models/catalogueItem/catalogueItemAuctionStatus.model";
import { accountService } from "../_services/accounts.service";
import { AuctionCatalogueStatusEnum } from "../_common/enum/auctionCatalogueStatus.enum";
import { AuctionPostbackStatusEnum } from "../_common/enum/auctionPostbackStatus.enum";
import { createResilientHubConnection } from "./signalRHub.helper";

type CatalogueStatusPayload = {
    auctionPostbackStatus?: CatalogueItemAuctionPostbackStatus & { catalogueItemId?: number; winnerUserIds?: string[] };
};

export function useCatalogueItemStatus(catalogueItemId: number | null, rejoinRef?: MutableRefObject<(() => Promise<void>) | null>) {
    const [catalogueItemStatus, setCatalogueItemStatus] = useState<CatalogueItemAuctionPostbackStatus | null>(null);
    const [connected, setConnected] = useState(false);

    useEffect(() => {
        if (!catalogueItemId) return;

        const applyStatus = (payload: CatalogueStatusPayload) => {
            const auctionPostbackStatus = payload?.auctionPostbackStatus;
            if (!auctionPostbackStatus || auctionPostbackStatus.catalogueItemId !== catalogueItemId) return;

            const winnerUserIds = auctionPostbackStatus.winnerUserIds ?? [];
            const currentUserId = accountService.currentUserValue?.id;

            if (auctionPostbackStatus.auctionCatalogueStatusId === AuctionCatalogueStatusEnum.ReOffered) {
                auctionPostbackStatus.auctionPostbackStatusId = winnerUserIds.includes(currentUserId) ? AuctionPostbackStatusEnum.ReOffered : AuctionPostbackStatusEnum.Lost;
            }
            if (auctionPostbackStatus.auctionCatalogueStatusId === AuctionCatalogueStatusEnum.Completed) {
                auctionPostbackStatus.auctionPostbackStatusId = winnerUserIds.includes(currentUserId) ? AuctionPostbackStatusEnum.Won : AuctionPostbackStatusEnum.Lost;
            }

            setCatalogueItemStatus({ ...auctionPostbackStatus, auctionPostbackStatus: auctionPostbackStatus });
        };

        return createResilientHubConnection({
            hubName: "catalogueItem",
            joinInvoke: {
                joinMethod: "JoinCatalogueItem",
                leaveMethod: "LeaveCatalogueItem",
                args: [catalogueItemId],
            },
            rejoinRef,
            onConnectedChange: setConnected,
            registerHandlers: (conn) => {
                conn.on("CatalogueItemStatusUpdated", (payload: CatalogueStatusPayload) => {
                    applyStatus(payload);
                });
            },
        });
    }, [catalogueItemId]);

    return { catalogueItemStatus, connected };
}
